export const reduxKey = "@@FEATURES_PAGE";
